import { memo } from 'react';
import { CustomError } from '../_tools/CustomError';
import { useSettingsContext } from '../context/settings';
import { ConfigError } from '../errors/ConfigError';
import useLocales from '../hooks/useLocales';
import { Modules } from '../modules/_definition/types';
import checkUndefinedNullOrEmpty from '../utils/tools/checkUndefinedNullOrEmpty';

type ConfigCheckProviderProps = {
    children: any;
    module: Modules;
    testError?: string;
};

function ConfigCheckProvider(props: ConfigCheckProviderProps) {
    const { children, module, testError } = props;
    const settings = useSettingsContext();
    const { translate } = useLocales();

    if (testError) throw new CustomError(translate, testError, undefined);
    else if (module !== Modules?.Print && module !== Modules?.ConfigListing && !settings?.general?.mockup) {
        if (checkUndefinedNullOrEmpty(settings?.general?.idFirma)) throw new ConfigError(translate, '001', undefined);
        else if (checkUndefinedNullOrEmpty(settings?.contact?.isLeadSystem)) throw new ConfigError(translate, '003', undefined);
        else if (checkUndefinedNullOrEmpty(settings?.contact?.linkDisclaimer)) throw new ConfigError(translate, '004', undefined);
        else if (!settings?.general?.enable) throw new ConfigError(translate, '005', undefined);
    }

    return children;
}

export default memo(ConfigCheckProvider);
